import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthContext } from '../../context/auth/AuthContextProvider'

const RequireNotDriver = () => {
  const location = useLocation()
  const { user } = useAuthContext()

  const isDriver = user.roles.find((role: string) => role === 'ROLE_DRIVER')

  if (isDriver) {
    return <Navigate to="/driver-view" state={{ from: location }} replace />
  }

  return <Outlet />
}

export default RequireNotDriver
